import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Page from '../Page';
import Footer from '../Shared/NewFooter';
import Header from '../Shared/NewHeader';
import { PageWrapper } from '../styles';

import { HOST_REQUIREMENTS } from '../../content/hostRequirements';
import copy from '../../content/list-your-venue';
import { Body, NoList, PrimaryButton, Wrapper } from './styles';

const words = copy.notAFit;

// The statements answered "No", from the router state the requirements page
// sends. A direct link has no state, so the list is left out.
const noStatements = (state) => {
  const requirements = state && HOST_REQUIREMENTS[state.version];
  if (!requirements || !Array.isArray(state.noIds)) return [];
  return requirements.statements.filter(({ id }) => state.noIds.includes(id));
};

const NotAFit = () => {
  const history = useHistory();
  const { state } = useLocation();
  const answeredNo = noStatements(state);

  // The app does not scroll to the top on a route change; start at the heading.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper>
      <Header omitSearch />
      <Wrapper>
        <Page title={words.title}>
          <Body>
            {answeredNo.length ? (
              <>
                <p>{words.intro}</p>
                <NoList>
                  {answeredNo.map(({ id, text }) => (
                    <li key={id}>{text}</li>
                  ))}
                </NoList>
              </>
            ) : (
              <p>{words.introNoAnswers}</p>
            )}
            <p>{words.why}</p>
            <p>
              {words.contact} <a href={`mailto:${copy.supportEmail}`}>{copy.supportEmail}</a>.
            </p>
            <PrimaryButton type="button" onClick={() => history.push('/list-your-venue')}>
              {words.back}
            </PrimaryButton>
          </Body>
        </Page>
      </Wrapper>
      <Footer />
    </PageWrapper>
  );
};

export default NotAFit;
